<div class="show-content-modal">
  <!-- contact-us-popup 形态：文本域内容，white-space: pre-line 保留换行（禅道 18937） -->
  <div class="show-content-modal__text" *ngIf="contentData.contentText">{{ contentData.contentText }}</div>
  <app-contents-of-article [content]="contentList" *ngIf="!contentData.contentText"></app-contents-of-article>
</div>
